/**
 * Pokazuje pola adresowe tylko wtedy, gdy użytkownik wybierze wysyłkę kurierską,
 * i przełącza ich wymagalność. Właściwa walidacja i tak odbywa się po stronie
 * serwera (includes/cf7-conditional-validation.php) — tutaj chodzi o szybszy
 * feedback w przeglądarce.
 */
export const initDeliveryMethod = () => {
  const shippingBox = document.querySelector("[data-shipping-fields]");

  if (!shippingBox) return;

  const form = shippingBox.closest("form");

  if (!form) return;

  const radios = form.querySelectorAll('input[name="delivery-method"]');

  if (!radios.length) return;

  const requiredFields = shippingBox.querySelectorAll(".is-shipping-required");

  /**
   * Nie porównujemy po pełnej etykiecie, bo treść opcji bywa zmieniana
   * w panelu CF7 — wystarczy, że w wartości pojawi się "wysyłka".
   */
  const isShippingValue = (value) =>
    typeof value === "string" && value.toLowerCase().includes("wysyłka");

  const toggleFields = () => {
    const selected = form.querySelector(
      'input[name="delivery-method"]:checked',
    );
    const isShipping = Boolean(selected && isShippingValue(selected.value));

    shippingBox.classList.toggle("is-visible", isShipping);

    requiredFields.forEach((field) => {
      field.required = isShipping;
      field.setAttribute("aria-required", isShipping ? "true" : "false");
    });

    // Ukryte pola czyścimy, żeby nie trafiły do wiadomości przy odbiorze osobistym.
    if (!isShipping) {
      shippingBox.querySelectorAll("input, textarea").forEach((field) => {
        field.value = "";
      });
    }
  };

  radios.forEach((radio) => {
    radio.addEventListener("change", toggleFields);
  });

  toggleFields();

  // Po wysłaniu formularza CF7 resetuje pola — przywracamy stan domyślny.
  document.addEventListener("wpcf7mailsent", toggleFields);
};
